export const textStandardValidations = {
  required: 'This field is required',
  minLength: {
    value: 3,
    message: 'Min Length is 3',
  },
}

export const emailValidation = {
  pattern: {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    message: 'Invalid email address',
  },
}
